import { render, staticRenderFns } from "./score-display.vue?vue&type=template&id=5e725946&"
import script from "./score-display.vue?vue&type=script&lang=ts&"
export * from "./score-display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports